import CertCategoryAll from "../Components/CertificationCategories/CertCategoryAll";

const CertAllCategoriesPage = () => {
  return (
    <div>
      <CertCategoryAll />
    </div>
  );
};

export default CertAllCategoriesPage;
